import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import { STATES_URL, CITIES_URL } from 'constants'

import Select from 'components/Select'
import AddLocation from 'modals/AddLocation'

import './styles.scss'

import { stateChanged, locationChanged } from 'scenes/NewClient/actions'


export class AdditionalData extends BaseComponent {
  constructor(props) {
    super(props)

    this.state = {
      states: [],
      cities: [],
      citieName: ''
    }

    this._bind('_fetchCities', '_fetchStates', '_showNewLocation', '_onLocationCreated')
  }

  componentDidMount() {
    this._fetchStates()
  }

  _fetchStates() {
    request(STATES_URL)
    .then((res) => {
      const states = res.states.map((state) => ({ value: state.id, label: state.name }))
      this.setState({ states })
    })
    .catch((err) => console.log(err))
  }

  _fetchCities(selectedOption) {
    const selectedState = !!selectedOption ? selectedOption.value : null,
      selectedName = !!selectedOption ? selectedOption.label : null
    this.props.stateChanged(selectedState, selectedName)
    this.props.locationChanged(null)

    if (!selectedState) {
      this.setState({ cities: []})
      return
    }

    request(CITIES_URL(selectedState))
      .then((res) => {
        const cities = res.cities.map((city) => ({ value: city.id, label: city.name }))
        this.setState({ cities })
      })
      .catch((err) => console.log(err))
  }

  _onLocationCreated(state, city) {
    this.props.stateChanged(state.id, state.name)
    this.props.locationChanged({
      value: city.id,
      label: city.name
    })
    this._fetchCities({
      value: state.id,
      label: state.name
    })
  }

  _showNewLocation() {
    this.context.toggleModal(true,
      <AddLocation  options={this.state.states}
                    onCreated={this._onLocationCreated}
                    state={this.props.state}
                    location={this.props.location} />
    )
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      citieName: nextProps.location.name
    })
  }


  render() {
    return (
      <div className="section-container location-data">
        <p className="bold-text title">Datos adicionales</p>
        <div>
          <div className="section-elements d-flex flex-column">
            <Select
              options={this.state.states}
              onChange={this._fetchCities}
              value={this.props.state.id}
              placeholder="Estado *"
            />
            <div className="d-flex align-items-center">
              <Select
                options={this.state.cities}
                value={this.props.location.id}
                onChange={this.props.locationChanged}
                placeholder="Localidad *"
              />
              <i onClick={this._showNewLocation} className="material-icons">add</i>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

AdditionalData.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}

const mapStateToProps = (state) => {
  return {
    state: state.newClient.get('state'),
    location: state.newClient.get('location')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    stateChanged: (id, name) => dispatch(stateChanged(id, name)),
    locationChanged: (selectedOption) => {
      const value = !!selectedOption ? selectedOption.value : null,
        name = !!selectedOption ? selectedOption.label : null
      dispatch(locationChanged(value, name))
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(AdditionalData)



// WEBPACK FOOTER //
// ./src/scenes/NewClient/components/AdditionalData/index.js